import { cellRenderParseDataAndTimeWithSeconds } from '../../utils/functions';

const columnDataGridHistoryMaster = [
  {
    dataField: 'actionNumId',
    caption: 'Id',
    notVisible: false,
    dataType: 'number',
    width: 100
  },
  {
    dataField: 'modDatetime',
    caption: 'Дата и время',
    notVisible: false,
    cellRender: cellRenderParseDataAndTimeWithSeconds,
    dataType: 'datetime',
    width: 160
  },
  {
    dataField: 'actionType',
    caption: 'Тип',
    notVisible: false,
    dataType: 'text',
    width: 160
  },
  {
    dataField: 'userFullName',
    caption: 'ФИО пользователя',
    notVisible: false,
    dataType: 'text',
    width: 300
  },
  {
    dataField: 'userName',
    caption: 'Логин',
    notVisible: false,
    dataType: 'text',
    width: 120
  }
];
export default columnDataGridHistoryMaster;
